import UserFilterSelect from './user-filter-select.jsx';
import UserList from './user-list.jsx';
import Store from '../store.js';
const { withSelect, withDispatch } = wp.data;

var applyWithSelect = withSelect( ( select, ownProps ) => {
	const { getStatisticUserFilter } = select( 'iportal-core' );
	return {
		userFilter: getStatisticUserFilter(),
	};
} );

var applyWithDispatch = withDispatch( ( dispatch, ownProps ) => {
	const { setStatisticUserFilter } = dispatch( 'iportal-core' );
  return {
		setUserFilter: setStatisticUserFilter
  };
} );

var Select = wp.compose.compose(
	applyWithSelect,
	applyWithDispatch,
)( UserFilterSelect );

for ( const element of document.querySelectorAll( '.user-filter-select') ) {
	wp.element.render( <Select/>, element );
}

var List = wp.compose.compose(
	applyWithSelect,
)( UserList );

for ( const element of document.querySelectorAll( '.statistic-user-list') ) {
	wp.element.render( <List content={element.querySelector( 'ul' ).innerHTML} filter={element.dataset.filter}/>, element );
}